exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  background-color: white;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.1);\n  justify-content: space-between;\n  align-items: center;\n  display: flex;\n  padding: 10px 30px;\n  width: 100%;\n  position: absolute;\n  box-sizing: border-box; }\n  .header__title {\n    margin: 0;\n    color: #15e1d5;\n    font-size: 16px; }\n    @media screen and (min-width: 768px) {\n      .header__title {\n        font-size: 20px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Header/header.scss
// module id = 5357
// module chunks = 0